module.exports = __webpack_public_path__ + "static/media/53.179446d3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/53.jpg
// module id = 743
// module chunks = 0